import store from './store'
import * as types from './store/mutation-types'

const CheckLIFFState = () => {
    let url = new URL(window.location.href);
    let state = url.searchParams.get('liff.state');
    if (state && state.charAt(0) !== "/") {
        url.searchParams.set('liff.state', '/' + state);
        window.history.replaceState(window.history.state, '', url);
    }
};

const LIFF = (isMini) => {

    CheckLIFFState();

    return liff.init({
        'liffId': isMini ? process.env.VUE_APP_LINE_MINI_LIFF: process.env.VUE_APP_LINE_BOT_LIFF,
    }).then(() => {
        if (!isMini && !liff.isLoggedIn() && liff.getLineVersion()) {
            liff.login({ redirectUri: location.href });
        }
        let context = liff.getContext();
        if (context.userId) {
            store.commit(types.SET_LINE_BOT_ID, context.userId);
            store.commit(types.SET_IS_LINE_MINI, isMini);
        }
    }).catch(err => {
        console.log(err);
    })
};

export default LIFF;
